var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerChat = function SvgCustomerChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.4,
    height: 46.4,
    x: 0.8,
    y: 0.8,
    fill: "#FAFBFE",
    rx: 11.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46.4,
    height: 46.4,
    x: 0.8,
    y: 0.8,
    stroke: "#D1D9E9",
    strokeWidth: 1.6,
    rx: 11.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customerChat_svg__a)",
    d: "M22 9.664h18.206l.187.197c.78 0 1.411.631 1.411 1.41V25.64c0 .779-.632 1.41-1.41 1.41l-.637.115c-.39 0-1.48.201-1.48.59l.098 2.237a.603.603 0 0 1-1.044.412l-2.105-1.967-.645-.692a1.57 1.57 0 0 0-1.146-.498H22.001a1.41 1.41 0 0 1-1.411-1.41V11.074c0-.78.631-1.411 1.41-1.411"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDAD71",
    d: "M40.59 9.664h-1.772a1.4 1.4 0 0 1 1.388 1.41v14.762a1.4 1.4 0 0 1-1.388 1.41H35.92a.7.7 0 0 0-.693.706v.484l2.203 2.36a.603.603 0 0 0 1.044-.41v-2.434c0-.39.316-.706.705-.706h1.411c.78 0 1.41-.631 1.41-1.41V11.075c.001-.78-.63-1.411-1.41-1.411"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.213 18.94h-8.737a.738.738 0 1 1 0-1.476h8.737a.738.738 0 1 1 0 1.476M37.955 15.479H24.566a.738.738 0 1 1 0-1.477h13.39a.738.738 0 0 1 0 1.476M37.957 22.61h-11.48a.738.738 0 1 1 0-1.476h11.48a.738.738 0 1 1 0 1.476"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customerChat_svg__b)",
    d: "m27 17.66-2.918-.196H8.41c-.78 0-1.411.632-1.411 1.41v14.762c0 .779.632 1.41 1.41 1.41h1.412c.39 0 .705.316.705.706v2.433a.603.603 0 0 0 1.044.412l2.849-3.052a1.57 1.57 0 0 1 1.146-.498h8.319L27 34.85c.78 0 1.214-.435 1.214-1.214V18.875c0-.78-.435-1.214-1.214-1.214"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4983E0",
    d: "M27.001 17.464h-1.603c.766 0 1.386.632 1.386 1.41v14.762c0 .779-.62 1.41-1.386 1.41h1.603c.78 0 1.411-.631 1.411-1.41V18.875a1.41 1.41 0 0 0-1.41-1.411"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.8 27.842a1.476 1.476 0 1 0 0-2.952 1.476 1.476 0 0 0 0 2.952m5.905 0a1.476 1.476 0 1 0 0-2.952 1.476 1.476 0 0 0 0 2.952m7.382-1.476a1.476 1.476 0 1 1-2.953 0 1.476 1.476 0 0 1 2.953 0",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "customerChat_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(125.375 13.305 14.547)scale(22.5787 24.1043)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "customerChat_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.2252 0 0 -28.1624 28.225 28.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C88EA"
  })))));
};
export default SvgCustomerChat;